var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGs11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 124,
    viewBox: "0 0 151 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1317_109437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6415 4.60972C47.8092 4.60972 48.7557 3.66316 48.7557 2.49553C48.7557 1.3279 47.8092 0.381348 46.6415 0.381348C45.4739 0.381348 44.5273 1.3279 44.5273 2.49553C44.5273 3.66316 45.4739 4.60972 46.6415 4.60972Z",
    fill: "#EF8459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2685 9.98276C42.4361 9.98276 43.3827 9.03621 43.3827 7.86858C43.3827 6.70095 42.4361 5.75439 41.2685 5.75439C40.1008 5.75439 39.1543 6.70095 39.1543 7.86858C39.1543 9.03621 40.1008 9.98276 41.2685 9.98276Z",
    fill: "#EF8459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9257 105.355C41.0933 105.355 42.0399 104.408 42.0399 103.241C42.0399 102.073 41.0933 101.126 39.9257 101.126C38.7581 101.126 37.8115 102.073 37.8115 103.241C37.8115 104.408 38.7581 105.355 39.9257 105.355Z",
    fill: "#EF8459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.202 121.112H109.902L109.771 112.38L112.202 112.242V121.112Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.79 123.343L105.371 123.343V123.247C105.372 122.481 105.677 121.747 106.218 121.206C106.759 120.664 107.494 120.36 108.259 120.359H112.79V123.343Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.365 118.463L123.257 119.382L119.646 111.43L121.82 110.333L125.365 118.463Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.996 123.237L119.957 123.149C119.806 122.802 119.724 122.428 119.717 122.048C119.71 121.669 119.778 121.292 119.917 120.939C120.055 120.586 120.262 120.264 120.526 119.991C120.789 119.718 121.103 119.499 121.451 119.348L125.604 117.537L126.797 120.273L119.996 123.237Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.287 52.1859C119.039 52.1859 121.27 49.9551 121.27 47.2033C121.27 44.4515 119.039 42.2207 116.287 42.2207C113.535 42.2207 111.305 44.4515 111.305 47.2033C111.305 49.9551 113.535 52.1859 116.287 52.1859Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.206 114.294L118.766 98.5623L121.894 83.842L115.96 83.52L112.694 99.9883L120.928 116.318L125.206 114.294Z",
    fill: "#F7CB70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.168 80.8979L115.132 99.7121L114.219 117.745L108.979 117.699L108.784 83.198L118.168 80.8979Z",
    fill: "#F7CB70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.333 81.9709L122.034 84.696L107.178 85.3607L108.184 81.2632L122.333 81.9709Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 87.1153C108.064 86.9364 107.959 86.731 107.897 86.5112C107.835 86.2913 107.817 86.0613 107.844 85.8345C107.872 85.6077 107.944 85.3886 108.057 85.1899C108.169 84.9911 108.32 84.8167 108.501 84.6768C108.577 84.6182 108.657 84.5658 108.741 84.5201L114.568 62.623L118.022 64.141L111.177 85.3013C111.34 85.6558 111.378 86.0551 111.286 86.4342C111.193 86.8133 110.975 87.1501 110.667 87.3898C110.304 87.6771 109.841 87.8095 109.38 87.7581C108.92 87.7067 108.498 87.4757 108.206 87.1153Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.889 56.9819L112.576 55.5623C112.576 55.5623 115.96 52.6369 119.529 54.3905L120.08 56.0293L122.99 60.7301L122.333 82.4427C122.333 82.4427 110.188 81.5192 107.178 82.6195L108.501 65.4144L111.889 56.9819Z",
    fill: "#4D5AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.521 84.5374L107.394 83.1031L112.136 68.2819L112.565 60.007C112.59 59.589 112.702 59.1809 112.895 58.8091C113.087 58.4372 113.355 58.1099 113.682 57.8483C114.076 57.5291 114.532 57.2948 115.02 57.1601C115.509 57.0254 116.02 56.9931 116.522 57.0654C118.198 57.2949 119.43 58.5762 119.453 60.1121L119.453 60.1196L119.452 60.127L117.805 71.7255L117.277 73.6136L112.521 84.5374Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.546 51.1085L119.68 51.3952L121.399 49.5677C121.399 49.5677 124.559 42.2391 117.576 41.1176C110.593 39.9961 112.118 42.8274 111.185 44.6029L114.038 45.3448L116.606 47.9698C116.606 47.9698 118.282 46.7425 118.774 47.8557C119.267 48.969 118.546 51.1085 118.546 51.1085Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8161 93.6135H0.888672V15.686H78.8161V93.6135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8161 93.6135H0.888672V15.686H78.8161V93.6135ZM2.04004 92.4621H77.6648V16.8374H2.04004V92.4621Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 49.186H16.9561V50.9503H66.9334V49.186Z",
    fill: "#F7CB70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 53.7729H16.9561V55.5372H66.9334V53.7729Z",
    fill: "#F7CB70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 58.3599H16.9561V60.1241H66.9334V58.3599Z",
    fill: "#F7CB70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9229 51.478C14.5587 51.478 15.0742 50.9625 15.0742 50.3267C15.0742 49.6908 14.5587 49.1753 13.9229 49.1753C13.287 49.1753 12.7715 49.6908 12.7715 50.3267C12.7715 50.9625 13.287 51.478 13.9229 51.478Z",
    fill: "#F7CB70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 29.4209H16.9561V31.1851H66.9334V29.4209Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 34.0078H16.9561V35.772H66.9334V34.0078Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 38.5947H16.9561V40.359H66.9334V38.5947Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9229 31.5205C14.5587 31.5205 15.0742 31.005 15.0742 30.3691C15.0742 29.7333 14.5587 29.2178 13.9229 29.2178C13.287 29.2178 12.7715 29.7333 12.7715 30.3691C12.7715 31.005 13.287 31.5205 13.9229 31.5205Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 69.1431H16.9561V70.9073H66.9334V69.1431Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 73.73H16.9561V75.4942H66.9334V73.73Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9334 78.3169H16.9561V80.0811H66.9334V78.3169Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9229 71.2432C14.5587 71.2432 15.0742 70.7277 15.0742 70.0918C15.0742 69.4559 14.5587 68.9404 13.9229 68.9404C13.287 68.9404 12.7715 69.4559 12.7715 70.0918C12.7715 70.7277 13.287 71.2432 13.9229 71.2432Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1317_109437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 123.237,
    fill: "white",
    transform: "translate(0.888672 0.381348)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs11);
export default __webpack_public_path__ + "static/media/GS11.16d1a82812d7e3c87dad652d092f0cc2.svg";
export { ForwardRef as ReactComponent };